import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useData } from '../contexts/DataContext';
import InvoiceGenerator from '../components/InvoiceGenerator';

const InvoicePage = () => {
    const { orderId } = useParams();
    const { orders } = useData();
    const navigate = useNavigate();

    const order = orders.find(o => o.id === orderId);

    if (!order) {
        return (
            <div className="alert alert-danger">
                Commande non trouvée
                <button onClick={() => navigate('/jobs')} className="btn btn-secondary ms-3">Retour</button>
            </div>
        );
    }

    return (
        <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Facturation - Commande {orderId.substr(0, 8)}</h2>
                <button onClick={() => navigate('/jobs')} className="btn btn-outline-secondary">Retour</button>
            </div>

            <div className="card shadow">
                <div className="card-body">
                    <InvoiceGenerator
                        order={order}
                        invoiceNumber={`F-${new Date().getFullYear()}-${Math.floor(Math.random() * 10000)}`}
                    />
                </div>
            </div>
        </div>
    );
};

export default InvoicePage;
